import { render, staticRenderFns } from "./ElementForm.vue?vue&type=template&id=d46ead7c&"
import script from "./ElementForm.vue?vue&type=script&lang=js&"
export * from "./ElementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports